null


// WEBPACK FOOTER //
// https://raw.githubusercontent.com/scala-js/scala-js-dom/v0.9.7/src/main/scala/org/scalajs/dom/package.scala